import React, { useState, useEffect } from 'react';
import styles from './styles.module.scss';

interface PasswordInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  innerRef?: React.Ref<HTMLInputElement>;
  error?: boolean;
}

export const PasswordInput: React.FC<PasswordInputProps> = ({
  innerRef,
  value,
  error,
  className,
  ...props
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsPasswordVisible(!isPasswordVisible);
  };

  useEffect(() => {
    if (value === '') {
      setIsPasswordVisible(false);
    }
  }, [value]);

  return (
    <div className={styles.wrapper}>
      <input
        className={`field ${error ? 'field--error' : ''} ${className || ''}`}
        type={isPasswordVisible ? 'text' : 'password'}
        ref={innerRef}
        value={value}
        {...props}
      />
      <button
        className={styles.toggleBtn}
        onClick={togglePasswordVisibility}
        type="button"
        aria-label="Toggle password visibility"
      >
        <i className={`icon ${isPasswordVisible ? 'icon-eye-slash' : 'icon-eye'}`} />
      </button>
    </div>
  );
};

export default PasswordInput;
